<template>
  <li>
    <a
      :id="id"
      :href="href"
      @click="openNavLink($event, href)"
      :class="`navigation-subnav-item ${isActive ? 'RouterLink-active' : ''}`"
      :tabindex="isOpen ? '0' : '-1'"
      :aria-current="isActive ? 'page' : undefined"
    >
      <span>{{ name }}</span>
    </a>
  </li>
</template>
<script>
import useSafeRoute from '@/app/composables/useSafeRoute';
import utils from '@/app/utils/utils';

export default {
  name: 'navigation-subnav-item',
  setup() {
    const route = useSafeRoute();
    return { route };
  },
  props: {
    id: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    externalLink: {
      type: Boolean,
      required: false,
    },
    href: {
      type: String,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    isActive() {
      return this.route.path.includes(utils.stripQuery(this.href));
    },
  },
  methods: {
    openNavLink(event, href) {
      if (this.externalLink) {
        return;
      }

      event.preventDefault();
      this.$bus.$emit('openMainNavLink', { href });
    },
  },
};
</script>
